const topics = [
  {
    title: "-Cinco de Mayo-",
    subtitle1: "Topic: 1",
    description: "1.B.1 Understand how culture, values, and beliefs shape people, places, and environments.",
    video: "",
    music: "",
    lyrics: [
   
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Holidays-",
    subtitle1: "Topic: 1",
    description: "1.B.1 Understand how culture, values, and beliefs shape people, places, and environments.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fholidays3rdgradeva.mp4?alt=media&token=9b8c3d1d-efbb-476b-b040-86df66f25236",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fholidays3rdgrade2022.mp3?alt=media&token=b1ef8a09-e63d-4a65-817e-eb1bdfccc528",
    lyrics: [
      "(Verse)",
"One day in January we remember",
"a man who worked hard so all people would be treated equal.",
"It’s a holiday,",
"Martin Luther King Jr. Day.",
"It’s a holiday,",
"Martin Luther King Jr. Day.",

"One day in February is for the greats.",
"We honor all presidents of The United States.",
"It’s a holiday,",
"Presidents Day.",
"It’s a holiday,",
"Presidents Day.",

"One day in May we remember",
"Americans who died during war while serving our country.",
"It’s a holiday,",
"Memorial Day.",
"It’s a holiday,",
"Memorial Day.",

"On the Fourth of July we celebrate",
"becoming a new country, America’s birthday.",
"It’s a holiday,",
"Independence Day, The 4th of July.",
"It’s a holiday,",
"Independence Day, The 4th of July.",

"One day in November we remember",
"Americans who served in the military.",
"It’s a holiday,",
"Veterans Day.",
"It’s a holiday,",
"Veterans Day.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Juneteenth-",
    subtitle1: "Topic: 1",
    description: "1.B.1 Understand how culture, values, and beliefs shape people, places, and environments.",
    video: "",
    music: "",
    lyrics: [
   
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Kwanzaa-",
    subtitle1: "Topic: 1",
    description: "1.B.1 Understand how culture, values, and beliefs shape people, places, and environments.",
    video: "",
    music: "",
    lyrics: [
     
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Pow Wow-",
    subtitle1: "Topic: 1",
    description: "1.B.1 Understand how culture, values, and beliefs shape people, places, and environments.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-What is Belief-",
    subtitle1: "Topic: 1",
    description: "1.B.1 Understand how culture, values, and beliefs shape people, places, and environments.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhatisbelief2025song.mp3?alt=media&token=88a35e67-628a-4f0b-8f85-974e20930d18",
    lyrics: [
      "(Chorus)",
"Beliefs are things we think are true.",
"They're part of me, they're part of you!",
"They help us know what’s wrong and right,",
"and guide us every day and night!",

"(Verse 1)",
"Some believe in helping out,",
"sharing kindness all about.",
"Some believe in being fair,",
"showing love and showing care!",
"Some believe in family ways,",
"special meals and holiday days.",
"Some believe in telling the truth,",
"honest words from me to you!",

"(Chorus)",
"Beliefs are things we think are true.",
"They're part of me, they're part of you!",
"They help us know what’s wrong and right,",
"and guide us every day and night!",

"(Verse 2)",
"Different people, different views,",
"but we respect what others do.",
"We can learn from what they say,",
"and live in kindness every day!",
"Different people, different views,",
"but we respect what others do.",
"We can learn from what they say,",
"and live in kindness every day!",

"(Chorus)",
"Beliefs are things we think are true.",
"They're part of me, they're part of you!",
"They help us know what’s wrong and right,",
"and guide us every day and night!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-What is Culture-",
    subtitle1: "Topic: 1",
    description: "1.B.1 Understand how culture, values, and beliefs shape people, places, and environments.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fwhatisculture2025song.mp3?alt=media&token=e0abf045-87fb-49e1-a138-407f7a73a381",
    lyrics: [
      "(Chorus)",
"Culture is how we live each day,",
"what we eat and what we say!",
"How we dance and what we do.",
"Culture is me, and culture is you!",

"(Verse 1)",
"Culture is the way we speak,",
"english, Spanish, maybe Greek!",
"Some say 'hello,' some say 'hi,'",
"some say 'bonjour' when you walk by!",
"Culture is the food we share,",
"pizza, pasta, everywhere!",
"Rice and beans or mac and cheese,",
"different flavors, same great feast!",

"(Chorus)",
"Culture is how we live each day,",
"what we eat and what we say!",
"How we dance and what we do.",
"Culture is me, and culture is you!",

"(Verse 2)",
"Culture’s in the songs we sing,",
"banjo, drum, or violin!",
"Clap your hands and stomp your feet,",
"music makes our world complete!",
"Holidays and special days,",
"families celebrate different ways!",
"Fireworks, lights, a big parade,",
"traditions that will never fade!",

"(Chorus)",
"Culture is how we live each day,",
"what we eat and what we say!",
"How we dance and what we do.",
"Culture is me, and culture is you!",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Yom Kippur-",
    subtitle1: "Topic: 1",
    description: "1.B.1 Understand how culture, values, and beliefs shape people, places, and environments.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fyomkippur2025song.mp3?alt=media&token=785ef37c-3b53-4ceb-8aaa-c104dca767f9",
    lyrics: [
      "(Chorus)",
"Yom Kippur is a special day,",
"A time to think, reflect, and pray.",
"Yom Kippur is a special day,",
"A time to think, reflect, and pray.",

"(Verse)",
"We say, 'I’m sorry,' and do what’s right,",
"To make our hearts feel big and light.",
"Some people fast, they do not eat.",
"They rest and pray, no snacks, no treat.",
"The shofar blows, a mighty sound.",
"A day of kindness all around.",
"At sunset, Yom Kippur is done.",
"A fresh new start for everyone!",

"(Chorus)",
"Yom Kippur is a special day,",
"A time to think, reflect, and pray.",
"Yom Kippur is a special day,",
"A time to think, reflect, and pray.",

"© Smart Board Learning, LLC. All rights reserved.",

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Citizenship-",
    subtitle1: "Topic: 1",
    description: "1.C&G.1 Understand how people engage with and participate in the community.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Civic Duties-",
    subtitle1: "Topic: 1",
    description: "1.C&G.1 Understand how people engage with and participate in the community.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Neighborhoods & Communities-",
    subtitle1: "Topic: 1",
    description: "1.C&G.1 Understand how people engage with and participate in the community.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Responsible Citizens-",
    subtitle1: "Topic: 1",
    description: "1.C&G.1 Understand how people engage with and participate in the community.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fresponsiblecitizen2025video.mp4?alt=media&token=c686e9e2-9c58-4d29-88ac-75835950a857",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fresponsiblecitizen2025song.mp3?alt=media&token=4fe0f14e-695b-4155-8ad4-696cbe08b452",
    lyrics: [
     "(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"(Verse)",
"Responsible citizens have civic duties.",
"Responsible citizens obey laws.",
"Responsible citizens serve on a jury,",
"Or as a witness, if they are called.",
"Responsible citizens have civic duties.",
"Responsible citizens pay their taxes.",
"Responsible citizens serve in the armed forces,",
"If they are called.",

"(Chorus)",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",
"I will be a responsible American citizen,",
"Because I love this country that we are living in.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Rights & Responsibilities-",
    subtitle1: "Topic: 1",
    description: "1.C&G.1 Understand how people engage with and participate in the community.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Rules & Laws-",
    subtitle1: "Topic: 1",
    description: "1.C&G.1 Understand how people engage with and participate in the community.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Goods & Services-",
    subtitle1: "Topic: 1",
    description: "1.E.1 Understand the role of basic economic concepts in the decisions people make.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Limited Resources-",
    subtitle1: "Topic: 1",
    description: "1.E.1 Understand the role of basic economic concepts in the decisions people make.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Producers & Consumers-",
    subtitle1: "Topic: 1",
    description: "1.E.1 Understand the role of basic economic concepts in the decisions people make.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Scarcity-",
    subtitle1: "Topic: 1",
    description: "1.E.1 Understand the role of basic economic concepts in the decisions people make.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Supply & Demand-",
    subtitle1: "Topic: 1",
    description: "1.E.1 Understand the role of basic economic concepts in the decisions people make.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Wants & Choices-",
    subtitle1: "Topic: 1",
    description: "1.E.1 Understand the role of basic economic concepts in the decisions people make.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Wants & Needs-",
    subtitle1: "Topic: 1",
    description: "1.E.1 Understand the role of basic economic concepts in the decisions people make.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Globe & Map-",
    subtitle1: "Topic: 1",
    description: "1.G.1 Apply geographic representations, tools, and terms to describe surroundings.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Landforms-",
    subtitle1: "Topic: 1",
    description: "1.G.1 Apply geographic representations, tools, and terms to describe surroundings.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fmotion2025song.mp3?alt=media&token=42c2ef01-e708-4c1a-bd92-80c832b82230",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "https://example.com/game-motion",
    titleImage: "", // Motion image URL
  },
  {
    title: "-My Map-",
    subtitle1: "Topic: 1",
    description: "1.G.1 Apply geographic representations, tools, and terms to describe surroundings.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/motion2025video.mp4?alt=media&token=3489343a-0d43-42d0-be14-b7d515f4165f",
    music: "",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Natural Barriers-",
    subtitle1: "Topic: 1",
    description: "1.G.1 Apply geographic representations, tools, and terms to describe surroundings.",
    video: "",
    music: "",
    lyrics: [
     
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Man-Made Environments-",
    subtitle1: "Topic: 1",
    description: "1.G.2 Understand interactions between humans and the environment in different places and regions around the world.",
    video: "",
    music: "",
    lyrics: [
      "When an object changes its position,",
      "That’s what we call motion!",
      "Let’s move forward, backward, side to side,",
      "And feel the motion inside!",
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Natural Resources-",
    subtitle1: "Topic: 1",
    description: "1.G.2 Understand interactions between humans and the environment in different places and regions around the world.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fnaturalresources2025video.mp4?alt=media&token=41ca1ac8-d85f-4732-a6e8-31c0c0f5024f",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fnaturalresources2025song.mp3?alt=media&token=970befde-e5f3-490c-b6b6-695a05fbb105",
    lyrics: [
      "(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 1)",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",
"Renewable resources are trees, fish, and horses.",
"All plants and animals, well,",
"they reproduce and replace themselves.",

"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",
"Nonrenewable resources are oil, gas, and coal.",
"They take millions of years to form,",
"so, once they’re used up, they’re gone.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"(Verse 2)",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",
"An inexhaustible resource is sunlight.",
"It will always be around during our lifetime.",

"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",
"Recyclable resources can be used more than once.",
"Some of these resources are copper, tin, and aluminum.",

"(Chorus)",
"Natural resources are resources,",
"found in nature and used by people.",
"Natural resources are resources,",
"found in nature and used by people.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-Pollution-",
    subtitle1: "Topic: 1",
    description: "1.G.2 Understand interactions between humans and the environment in different places and regions around the world.",
    video: "",
    music: "",
    lyrics: [
      
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-American Flag-",
    subtitle1: "Topic: 1",
    description: "1.H.1 Understand how people and events have changed society over time.",
    video: "",
    music: "",
    lyrics: [
     "(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"(Verse 1)",
"With stars and stripes, here we stand.",
"A flag waves proudly, across the land.",
"Through the breeze we see freedom dance.",
"Come one, come all, come take a chance.",
"With fifty stars, we see them blooming,",
"As the 50 States of the Union.",
"Thirteen stripes will always follow me,",
"And represent the thirteen original colonies.",

"(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"(Verse 2)",
"Patriotism is in everyone’s heart.",
"A love for our country, a love with a spark.",
"In its colors, find joy and pride.",
"The America's spirit will forever fly.",
"With fifty stars, we see them blooming,",
"As the 50 States of the Union.",
"Thirteen stripes will always follow me,",
"And represent the thirteen original colonies.",

"(Chorus)",
"Our flag, our flag, our flag fly free.",
"Our flag, our flag, our flag’s in me.",
"Fifty stars, thirteen stripes.",
"Flying high, so bold and bright.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-NC State Bird-",
    subtitle1: "Topic: 1",
    description: "1.H.1 Understand how people and events have changed society over time.",
    video: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/videos%2Fncstatebird2025video.mp4?alt=media&token=f5beb73f-9faa-47af-8a51-c5f1fe0fe0d3",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fncstatebird2025song.mp3?alt=media&token=73e36459-fee6-4cd2-bc04-781ff085e537",
    lyrics: [
      "(Verse)",
"The State bird is the Cardinal.",
"The State bird is the Cardinal.",
"Named after the Catholic cardinals who dressed in bright red robes.",

"The male Cardinal has a red beak.",
"The male Cardinal has a red beak.",
"The male Cardinal has a red body, red head, red tail, and red wings.",

"The female Cardinal is brown.",
"The female Cardinal is brown.",
"They have red beaks and red wings,",
"that you can see when they fly around.",

"The Cardinal is a songbird.",
"The Cardinal is a songbird.",
"The Cardinal has a loud, whistling song that can be heard.",

"The Cardinal is red and pretty.",
"The Cardinal is red and pretty.",
"The Cardinal became the state bird of North Carolina in 1943.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-NC State Flower-",
    subtitle1: "Topic: 1",
    description: "1.H.1 Understand how people and events have changed society over time.",
    video: "",
    music: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/music%2Fdogwood2025song.mp3?alt=media&token=3a291f46-ade2-4520-bb57-bc2a7c9e9735",
    lyrics: [
      "(Chorus)",
"My state flower is good.",
"My state flower is the Dogwood.",
"With 4 white petals surrounding green clusters in the middle.",
"During the fall, their colors change like Skittles.",

"My state flower is good.",
"My state flower is the Dogwood.",
"With 4 white petals surrounding green clusters in the middle.",
"During the fall, their colors change like Skittles.",

"(Verse)",
"State flower is good.",
"State flower is Dogwood.",
"The outside’s white, center green.",
"State flower since 1941.",

"Dogwood blooms in spring.",
"Pretty white, sometimes pink.",
"In the fall, the leaves change",
"beautiful colors, red and orange.",

"Then the leaves fall in winter, the leaves fall in winter,",
"the leaves fall in winter, the leaves fall in winter.",

"Dogwood blooms in spring.",
"Pretty white, sometimes pink.",
"In the fall, the leaves change",
"beautiful colors, red and orange.",

"(Chorus)",
"My state flower is good.",
"My state flower is the Dogwood.",
"With 4 white petals surrounding green clusters in the middle.",
"During the fall, their colors change like Skittles.",

"My state flower is good.",
"My state flower is the Dogwood.",
"With 4 white petals surrounding green clusters in the middle.",
"During the fall, their colors change like Skittles.",

"© Smart Board Learning, LLC. All rights reserved.",
    ],
    game: "",
    titleImage: "", // Motion image URL
  },
  {
    title: "-NC State Flag-",
    subtitle1: "Topic: 1",
    description: "1.H.1 Understand how people and events have changed society over time.",
    video: "",
    music: "",
    lyrics: [

    ],
    game: "",
    titleImage: "", // Motion image URL
  },

];
export default topics;